/** Shared cart line shape (persisted under `amber-unikit-cart`). */
export interface CartItem {
  id?: number;
  /** CMS product slug for deep links */
  slug?: string;
  /** Category URL segment, e.g. `complete`, `extras` */
  categorySlug?: string;
  /** Display name (CMS product title); same product with different options = different lines. */
  name: string;
  price: number;
  image: string;
  quantity: number;
  options?: Record<string, string>;
}

/** Stable id for a cart line: product `name` + sorted `options` (same as merge/update/remove keys). */
export function getCartLineKey(item: Pick<CartItem, "name" | "options">): string {
  const opts = item.options;
  if (!opts || Object.keys(opts).length === 0) return item.name;
  const sorted = Object.keys(opts)
    .sort((a, b) => a.localeCompare(b))
    .map((k) => `${k}=${opts[k]}`)
    .join("\u001e");
  return `${item.name}\u001e${sorted}`;
}
